<template>
  <TableLayout :permissions="['business:sites:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="站点编号" prop="code">
        <el-input v-model="searchForm.code" placeholder="请输入站点编号" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="站点名称" prop="name">
        <el-input v-model="searchForm.name" placeholder="请输入站点名称" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        border
      >
        <el-table-column prop="code" label="站点编号" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="name" label="站点名称" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="allLockNum" label="锁头数量" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="bikeCount" label="在架车数量" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="rate" label="满架率" min-width="100px" align="center">
          <template slot-scope="{row}">
            <span>{{ (row.rate * 100).toFixed(0) }}%</span>
          </template>
        </el-table-column>
        <el-table-column prop="editDate" label="最后通讯时间" min-width="100px" align="center"></el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
export default {
  name: 'Sites',
  extends: BaseTable,
  components: { TableLayout, Pagination },
  data () {
    return {
      // 搜索
      searchForm: {
        name: '',
        code: '',
      }
    }
  },
  created () {
    this.config({
      module: '站点信息表',
      api: '/business/sitesBike',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  }
}
</script>
